export const environment = {
  instrumentationKey: "fafa62c7-c13f-4fe5-8f94-8ee060ea8df6",
  production: true,
  API_BASE: "https://gospread-api.azurewebsites.net/",
  useHubV2: true,
  stripe: {
    publishKey:
      "pk_test_51TEyPnJoP1ybifWeFgLIks4PTd24ekemZLe1gp5rhM3Zu3Jdx4vkbiPxr4eTddMjF6VO1BgaQNMDw4y9XZXogwC500tOsLtQSr",
  },
  // stripe: {
  //   publishKey:
  //     "pk_live_51OFKEaJJFwPkxJmSHL9LQjZhplUcXVXsuKK5DSSTPbT3RB8imIKIgIiW2hJzPPkBfZFfOOV3QePoTcHiujqv5a7b00CK06z84z",
  // },
};
